import type { VideoItem } from '@/mocks/videoData';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all hover:scale-[1.02]">
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - ${video.platform}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
          {video.duration}
        </span>
        <span className="absolute top-2 left-2 bg-primary-500/90 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
          {video.rating}分
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full">
            <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug mb-2">
          {video.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
          <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-md text-xs whitespace-nowrap">
            {video.platform}
          </span>
        </div>
      </div>
    </article>
  );
}